module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KECHENGMINGCHENG')
    }
  }, [_vm._v(_vm._s(_vm.item.name))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SUOSHUZUZHI')
    }
  }, [_vm._v(_vm._s(_vm.item.domainName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('GUANLIWEIDU')
    }
  }, [_vm._v(_vm._s(_vm.item.dimensionNames))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KESHI')
    }
  }, [_vm._v(_vm._s(_vm.item.hour))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('XUEFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.score))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIANGSHI')
    }
  }, [_vm._v(_vm._s(_vm.item.teacherName))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KECHENLEIBIE')
    }
  }, [_vm._v(_vm._s(_vm.item.courseTypeName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KECHENJIBIE')
    }
  }, [_vm._v(_vm._s(_vm.item.courseLevelName))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec7a52e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/publishOnlineCourseAudit.vue
// module id = 923
// module chunks = 80